import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Modal, 
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Table,
} from "reactstrap";
import { get, post } from "helpers/api_helper";
import SweetAlert from "react-bootstrap-sweetalert";

//i18n
import { withTranslation } from "react-i18next";

const ModalAddSAMember = (props) => {
    //form
    const [email, setEmail] = useState("")
    const [users, setUsers] = useState([])
    const [teacherId, setTeacherId] = useState("")
    const [loadingSearch, setLoadingSearch] = useState(false)
    //alert
    const [warning_alert, setWarningAlert] = useState(false)
    const [message_alert, setmessage_alert] = useState(false)
    const [text_message_alert, settext_message_alert] = useState("")
    const [error_alert, seterror_alert] = useState(false)
    //saving
    const [loading, setLoading] = useState(false);


    const searchTeachers = async () => {
        setTeacherId("")
        if (email.length < 5) {
            alert("Email minimal 5 karakter")
            return
        }

        try {
            setLoadingSearch(true)

            const res = await get(`/user/teachers?email=${email}`)
            const data = res.data.data

            setUsers(data || [])
        } catch (err) {
            seterror_alert(true)
        } finally {
            setLoadingSearch(false)
        }
    }
    
    const saveDataCutoff = async () => {
        if(teacherId === ""){
            setWarningAlert(true)
        }else{
            setUsers([])
            setEmail("")
            const body = {
                user_id: teacherId,
            }
            try {
                setLoading(true);
                let response = await post(`/early-dismissal/sa-members`, body)
                if (response) {
                    setmessage_alert(true)
                    settext_message_alert("Success Add SA Member")
                }
            } catch (error) {
                seterror_alert(true)
            } finally {
                setLoading(false);
            }
        }
        
    }

    const closeModal = () => {
        setUsers([])
        setEmail("")
        props.toggleModal();
    }

    return(
        <>
            <Modal
                size="lg"
                centered={true}
                isOpen={props.modalShow}
                toggle={props.toggleModal}
            >
                <ModalHeader toggle={props.toggleModal}>Add SA Member</ModalHeader>
                <ModalBody>
                    <Form>
                        <Row className="align-items-center">
                            <Col md="10">
                                <FormGroup>
                                    <Label for="email">Email</Label>
                                        <Input
                                        type="text"
                                        id="email"
                                        placeholder="Input email minimal 5 character"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        />
                                </FormGroup>
                                </Col>

                            <Col md="2" className="d-flex align-items-center">
                                <Button
                                    color="primary"
                                    className="btn-sm w-100 mt-3"
                                    onClick={searchTeachers}
                                    disabled={loadingSearch}
                                >
                                    {loadingSearch ? "Searching..." : "Search"}
                                </Button>
                            </Col>
                        </Row>

                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label>Select Teacher</Label>

                                    <div
                                        style={{
                                            maxHeight: "250px",
                                            overflowY: "auto",
                                            border: "1px solid #ced4da",
                                            borderRadius: "5px"
                                        }}
                                    >
                                        <Table hover responsive className="mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                <th width="50">#</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {users.length === 0 && (
                                                <tr>
                                                    <td colSpan="3" className="text-center">
                                                    No data
                                                    </td>
                                                </tr>
                                                )}

                                                {users.map((user, index) => (
                                                <tr
                                                    key={user.id}
                                                    onClick={() => setTeacherId(user.id)}
                                                    style={{
                                                    cursor: "pointer",
                                                    backgroundColor:
                                                        teacherId === user.id ? "#e3f2fd" : "transparent"
                                                    }}
                                                >
                                                    <td>
                                                    <Input
                                                        type="radio"
                                                        checked={teacherId === user.id}
                                                        onChange={() => setTeacherId(user.id)}
                                                    />
                                                    </td>

                                                    <td>{user.full_name}</td>
                                                    <td>{user.email}</td>
                                                </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md="12">
                                <div className="d-flex flex-row-reverse">
                                    <Button className="btn-sm" color="danger" onClick={closeModal}>
                                        Cancel
                                    </Button>

                                    <Button
                                        className="btn-sm mx-1"
                                        color="primary"
                                        onClick={saveDataCutoff}
                                    >
                                    {loading ? (
                                        <>
                                        <span className="spinner-border spinner-border-sm me-1" />
                                        Saving...
                                        </>
                                    ) : (
                                        "Simpan"
                                    )}
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
            {warning_alert && (
                <SweetAlert
                warning
                title="Warning"
                onConfirm={() => setWarningAlert(false)}
                >
                Pilih teacher terlebih dahulu!
                </SweetAlert>
            )}
            {message_alert ? (
                <SweetAlert
                    title="Success!"
                    confirmBtnText="Yes"
                    success
                    confirmBtnBsStyle="primary"
                    onConfirm={() => {
                        setmessage_alert(false)
                        props.toggleModal();
                        props.onSuccess();
                    }}
                >
                    {text_message_alert}
                </SweetAlert>
                ) : null}
        
                {error_alert ? (
                <SweetAlert
                    title="Oppss!"
                    confirmBtnText="Yes"
                    error
                    confirmBtnBsStyle="primary"
                    onConfirm={() => {
                        seterror_alert(false)
                    }}
                >
                    Something wrong, please try again
                </SweetAlert>
                ) : null}
        </>
    )
}

ModalAddSAMember.propTypes = {
    toggleModal: PropTypes.any,
    modalShow: PropTypes.any,
    onSuccess: PropTypes.any,
};

export default withTranslation()(ModalAddSAMember);